export default {
  'pt-br': 'pt-br',
  'en-us': 'en',
};
